// Tiny transient status toast, ported from account.js. Imperative so any code
// (modal, menu) can fire one without a React subtree.
let toastTimer: number | null = null;

export function toast(message: string): void {
  let host = document.querySelector<HTMLDivElement>(".toast");
  const fresh = !host;
  if (!host) {
    host = document.createElement("div");
    host.className = "toast";
    host.setAttribute("role", "status");
    host.setAttribute("aria-live", "polite");
    document.body.append(host);
  }
  const show = () => {
    host!.textContent = message;
    host!.classList.add("is-visible");
  };
  if (fresh) requestAnimationFrame(show);
  else show();
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => host!.classList.remove("is-visible"), 3600);
}
